import { ErrorMessage, Field, Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dummy_profile_pic, tier1 } from "../../../assets/assets";
import Autocomplete from "react-google-autocomplete";
import {
  getStorageValue,
  getZipCode,
  Regex,
  setStorageKey,
  zipObjectCovert,
} from "../../../service/shared.service";
import * as Yup from "yup";
import httpApiCall from "../../../service/api.service";
import toastr from "../../elements/toast";
import { Button, Modal, Spinner } from "react-bootstrap";
import ReactCrop, { Crop } from "react-image-crop";
import "react-image-crop/src/ReactCrop.scss";
import { savePartnerProfileData } from "../../../Redux/Slices/MainSlice";
import InputMask from "react-input-mask";

const Info = () => {
  const lang = useSelector(
    (state: any) => state?.APIData?.getSetting?.language_data
  );
  const toastrService = new toastr(true);
  const [image, setImage] = useState(dummy_profile_pic);
  let partnerData: any = getStorageValue("partnerData");
  let countryData = partnerData.country_currency_info.country;
  let countries:any = [];
  countries.push(countryData["country_code"]);
  const US_UT_country_codes = ["VI", "PR", "GU", "AS", "MP"];
  if (countryData["country_code"] == "US") {
    countries = [...countries, ...US_UT_country_codes];
  }

  const profileData = useSelector(
    (state: any) => state?.APIData?.partnerProfileData
  );
  // {
  //   if (state?.APIData?.partnerProfileData && state?.APIData?.partnerProfileData.partner_profile && state?.APIData?.partnerProfileData.partner_profile.length) {
  //     setImage(state?.APIData?.partnerProfileData.partner_profile[0].profile_image);
  //   }
  //   return state?.APIData?.partnerProfileData
  // });
  // let userData = partnerData && partnerData.partner_profile && partnerData.partner_profile.length ? partnerData.partner_profile[0] : {};
  const mapApiKey = getStorageValue("map_api_key");
  const userData =
    partnerData &&
    partnerData.partner_profile &&
    partnerData.partner_profile.length
      ? partnerData.partner_profile[0]
      : {};
  const [show, setShow] = useState(false);
  const [hidezipCode, setHidezipCode] = useState(false);
  const [url, setUrl] = useState("");
  const [urlImage, setUrlImage] = useState("");
  const [cityId, setCityId] = useState();
  const dispatch = useDispatch();
  const [crop, setCrop] = useState<Crop>({
    unit: "%",
    x: 25,
    y: 25,
    width: 50,
    height: 50,
  });
  const [phoneRegex, setPhoneRegex] = useState<{
  phoneRegexLength: string;
  phone_length: string | number;
  min_phone_length: string | number;
}>({
  phoneRegexLength: "",
  phone_length: "",
  min_phone_length:""
});
  const [sppiner, setSppiner] = useState(false);

  const [info, setInfo] = useState({
    name: userData?.partner_name || "",
    email: userData?.partner_email || "",
    phone: userData?.partner_mobile || "",
    address: (userData?.partner_address && userData?.partner_address) || "",
    zip: userData?.zip || "",
    city: userData?.city || "",
    state: userData?.state_name || "",
    language: userData.language_preffered || "",
  });

  useEffect(() => {
    if (
      profileData &&
      profileData.country_currency_info &&
      profileData.country_currency_info.country
    ) {
      updateMasking(
        profileData.country_currency_info.country["country_phone_format"]
      );
      setPhoneRegex((data) => ({
      ...data,
      phone_length: profileData?.country_currency_info['phone_length'] || 12,
      min_phone_length: profileData?.country_currency_info['min_phone_length'] || 7
    }));
    }
    if (
      profileData &&
      profileData.partner_profile &&
      profileData.partner_profile.length
    ) {
      setUrlImage(profileData.partner_profile[0].partner_image);
    } else if (userData && userData.profile_image) {
      setUrlImage(userData.profile_image);
    } else {
      setUrlImage(dummy_profile_pic);
    }
    if (
      partnerData &&
      partnerData.country_currency_info &&
      partnerData.country_currency_info.country
    ) {
      partnerData["country_code"] =
        partnerData.country_currency_info.country["country_code"];
    }
  }, [profileData]);

  const countryRestrictions = userData?.country_code
    ? { country: userData.country_code }
    : undefined;

  const updateMasking = (format: "") => {
    const phoneRegexVar = format?.replace(/#/g, "9");
    // phoneRegex = phoneRegexVar;
   setPhoneRegex((data) => ({
      ...data,
      phoneRegexLength: phoneRegexVar
    }));
  };

  const onPhoneChange = (event: any, setFieldValue: any) => {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/[^0-9]+/g, "");
    }
    // console.log(event.target.value);
    setInfo((businessData) => ({
      ...businessData,
      phone: event.target.value,
    }));
    setFieldValue("phone", event.target.value);
  };

  const uploadImage = (e: any) => {
    const file = e?.target?.files?.[0];
    console.log(file);
    
    if (file && file.type.startsWith("image/")) {
      setImage(file);
      const reader = new FileReader();
      reader.onload = (event: any) => {
        if (event.target) {
          setUrl(event.target.result);
        }
      };
      reader.readAsDataURL(file);
      handleShow();
      e.target.value = null;
    } else {
      toastrService.showError("Please select a valid image file.");
      return;
    }
  };

  const handleClose = () => {
    setShow(false);
    setCrop({
      unit: "%", // Can be 'px' or '%'
      x: 25,
      y: 25,
      width: 50,
      height: 50,
    });
  };

  const handleShow = () => setShow(true);

  const getCroppedImg = async (image: any, crop: any, fileName: any) => {
    image = await createImage(url);
    const uploadedImage: any = document.getElementById("uploadedImage");
    const scaleX = image.naturalWidth / uploadedImage?.clientWidth;
    const scaleY = image.naturalHeight / uploadedImage?.clientHeight;
    // new OffscreenCanvas(image.naturalWidth * image.width, image.naturalHeight * image.height) //
    const canvas = document.createElement("canvas");
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx: any = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob: any) => {
        if (!blob) {
          toastrService.showError("Please crop the image");
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        // window.URL.revokeObjectURL(this.fileUrl);
        const fileUrl = window.URL.createObjectURL(blob);
        // console.log(fileUrl);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  };

  const handleFileUpload = async () => {
    setSppiner(true);
    // console.log(crop, "Crop");
    const croppedImageUrl: any = await getCroppedImg(url, crop, "test");
    let fd = new FormData();
    // fd.append('profile_image', file);
    // fd.append('partner_id', userData.partner_id); // Assuming partner_id is a string
    // fd.append('access_token', userData.access_token); // Assuming access_token is a string
    const body = {
      access_token: userData.access_token,
      profile_image: image,
      partner_id: userData.partner_id,
    };
    let ppData: any;
    httpApiCall({
      api: "edit_partner_image",
      type: "form",
      body,
      content_type: "multipart/form-data",
    })
      .then((data) => {
        setUrlImage(image);
        setSppiner(false);

        if (data && data.is_error === 0) {
          toastrService.showSuccess("Update Successfully");
          if (croppedImageUrl) {
            setImage(croppedImageUrl);
            handleClose();
          }
          if (data.partner_profile && data.partner_profile.partner_image) {
            if (
              profileData &&
              profileData.partner_profile &&
              profileData.partner_profile.length
            )
              ppData = JSON.parse(JSON.stringify(profileData));
            ppData.partner_profile[0]["partner_image"] =
              data.partner_profile.partner_image;
            dispatch(savePartnerProfileData(ppData));
          }
        } else {
          toastrService.showError(data?.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setInfo({
      ...info,
      [name]: value,
    });
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Please enter name")
      .matches(Regex.name, "Invalid first name"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Please enter a valid email"),
    phone: Yup.string()
      .required("Please enter a phone number").min(+phoneRegex.min_phone_length, `Phone number is not valid`).max(+phoneRegex.phone_length, `Phone number is not valid`),
    // language: Yup.string().required("Please select language"),
    address: Yup.string().required("Please enter Address"),
    // city: Yup.string().required("Please enter City"),
    zip: Yup.string().required("Please enter Zip Code"),
    // state: Yup.string().required("Please enter State"),
  });

  const placeSelectedZip = async (place: any, setFieldValue: any) => {
    setSppiner(true);
    setHidezipCode(true);
    const placeData = await getZipCode(zipObjectCovert(place));
    if (placeData) {
      info.zip = placeData.zip;
      info.city = placeData.city;
      info.state = placeData.state_name;
      setInfo((data: any) => ({
        ...data,
        zip: placeData.zip,
        city: placeData.city,
        state: placeData.state_name,
      }));
      setSppiner(false);
      setFieldValue("zip", placeData.zip);

      // console.log(placeData,"nnnn");
      setCityId(placeData.city_id);
      setFieldValue("state_name", placeData.state_name);
      setFieldValue("city_name", placeData.city);
      // setTimeout(() => {
      //   setFieldValue({
      //     city: placeData.city,
      //     state: placeData.state_name,
      //     zip: placeData.zip,
      //   })
      // }, 0)
    }
    setHidezipCode(false);
  };

  const createImage = (url: any) =>
    new Promise((resolve, reject) => {
      const image: any = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error: any) => reject(error));
      image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
      image.src = url;
    });
  const handleSubmit = async (values: any) => {
    setSppiner(true);
    const body = {
      access_token: userData.access_token,
      partner_name: values.name ? values.name : info.name,
      partner_email: values.email ? values.email : info.email,
      partner_mobile: values.mobile ? values.phone : info.phone,
      language_preffered: info.language,
      partner_address: values.address ? values.address : info.address,
      partner_mobile_country_code: countryData.mobile_code,
      city_id: cityId ? cityId : userData.city_id,
      country_id: countryData.country_id,
      currency_id: userData.currency_id,
    };
    // console.log(body, "body");

    await httpApiCall({ api: "edit_profile", type: "post", body })
      .then((data) => {
        setSppiner(false);
        if (data && data.is_error === 0) {
          // console.log(data);
          setStorageKey("partnerProfile", data.partner_profile);
          toastrService.showSuccess("Update Successfully");
        } else {
          toastrService.showError(data?.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("Error in Register:", error);
      });
  };
  return (
    <div>
      <div className="info">
        <div className="info-header">
          <h1>General Information</h1>
        </div>

        <div className="user-info">
          <div className="user-img">
            <img
              src={urlImage ? urlImage : dummy_profile_pic}
              alt="img"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = dummy_profile_pic;
              }}
            />
          </div>

          <div className="upload-img">
            <input id="file" type="file" accept="image/jpg, image/jpeg, image/png, image/svg" onChange={(e: any) => uploadImage(e)} />{" "}
            <span className="upload" id="uploadImage">Upload Image</span>
          </div>
        </div>

        <div className="user-form bank_information">
          <div className="row">
            <div className="col-xl-8">
              <Formik
                onSubmit={handleSubmit}
                initialValues={info}
                validationSchema={validationSchema}
              >
                {({ setFieldValue, dirty }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="name" className="bank_label">Name</label>
                          <Field
                            type="text"
                            name="name"
                            id=" user_name"
                            className="form-control"
                            autoComplete="name"
                            // value={info.name}
                            // onChange={(e: any) => handleInputChange(e)}
                          />
                          <small className="text-danger">
                            <ErrorMessage name="name" className="error" />
                          </small>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="name" className="bank_label">Email</label>
                          <Field
                            type="email"
                            name="email"
                            id="email "
                            className="form-control"
                            disabled
                            // value={info.email}
                            // onChange={(e: any) => handleInputChange(e)}
                          />
                          <small className="text-danger">
                            <ErrorMessage name="email" />
                          </small>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="name" className="bank_label">Phone-Number</label>
                          <div
                            className={`${
                              info.phone && info.phone.length
                                ? "phone_input"
                                : ""
                            }`}
                          >
                            {info.phone && info.phone.length && (
                              <span className="code">
                                {userData?.partner_mobile_country_code}
                              </span>
                            )}
                            <Field name="phone">
                              {(props: any) => (
                                <InputMask
                                  type="text"
                                  id="phone-profile"
                                  mask={phoneRegex.phoneRegexLength}
                                  maskChar={null}
                                  value={info.phone}
                                  onChange={(event) =>
                                    onPhoneChange(event, setFieldValue)
                                  }
                                  className="text-input form-control phone_masking"
                                   minLength={+phoneRegex.min_phone_length}
                                  maxLength={+phoneRegex.phone_length}
                                />
                              )}
                            </Field>
                          </div>
                          <small className="text-danger">
                            <ErrorMessage name="phone" />
                          </small>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="name" className="bank_label">
                            Preferred communication language (Email/SMS)
                          </label>
                          <div className="arrowSelectSmall">

                          <Field
                            as="select"
                            name="language"
                            id=""
                            className="form-control"
                            onChange={(e: any) => {
                              handleInputChange(e);
                              setFieldValue("language", e.target.value);
                            }}
                          >
                            {lang?.map((item: any, index: any) => {
                              return (
                                <option key={index} value={item.lan_code}>
                                  {item.lan_name}
                                </option>
                              );
                            })}
                          </Field>
                          </div>

                          <small className="text-danger">
                            <ErrorMessage name="language" />
                          </small>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="name" className="bank_label">Address</label>
                          <Field
                            type="text"
                            name="address"
                            id="Address"
                            className="form-control"
                            autoComplete="address"
                          />
                          <small className="text-danger">
                            <ErrorMessage name="address" />
                          </small>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="postalCode">ZipCode</label>
                          {userData?.partner_mobile_country_code &&
                            countryData.country_code && (
                              <div
                              id="zip"
                                style={{
                                  border: "solid 1px #dee2e6",
                                  borderRadius: "0.375rem",
                                  minHeight: "42px",
                                }}
                              >
                                {!hidezipCode && (
                                  <Autocomplete
                                    apiKey={mapApiKey}
                                    className="form-control"
                                    id="zip-input"
                                    style={{
                                      width: "100%",
                                      height: "40px",
                                      paddingLeft: "16px",
                                      border: 0,
                                    }}
                                    onPlaceSelected={(place) => {
                                      placeSelectedZip(place, setFieldValue);
                                    }}
                                    options={{
                                      fields: [
                                        "address_components",
                                        "adr_address",
                                        "geometry",
                                        "name",
                                        "formatted_address",
                                      ],
                                      types: ["(regions)"],
                                      componentRestrictions: {
                                        country: countries,
                                      },
                                    }}
                                    defaultValue={info.zip}
                                  />
                                )}
                              </div>
                            )}
                          <ErrorMessage
                            name="zip"
                            component="small"
                            className="text-danger m-2"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="name" className="bank_label">City</label>
                          <Field
                            type="text"
                            name="city"
                            id=" city"
                            className="form-control"
                            disabled
                            value={info.city}
                            // onChange={(e: any) => handleInputChange(e)}
                          />
                          <ErrorMessage
                            name="city"
                            component="small"
                            className="text-danger m-2"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="name" className="bank_label">State</label>
                          <Field
                            type="text"
                            name="state"
                            id="state "
                            className="form-control"
                            disabled
                            value={info.state}
                            // onChange={(e: any) => handleInputChange(e)}
                          />
                          <ErrorMessage
                            name="state"
                            component="small"
                            className="text-danger m-2"
                          />
                        </div>
                      </div>
                    </div>

                    <div>
                      <button
                        disabled={sppiner}
                        type="submit"
                        className={`btn-button `}
                      >
                        Update{" "}
                        {sppiner && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <div className="image-cropper">
          <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <ReactCrop crop={crop} onChange={(c) => setCrop(c)}>
                <img
                  src={url}
                  alt="Crop me"
                  className="w-100"
                  id="uploadedImage"
                />
              </ReactCrop>
            </Modal.Body>
            <Modal.Footer className=" d-flex justify-content-between">
              <Button
                disabled={sppiner}
                variant="secondary"
                onClick={handleClose}
                id="closeButton"
              >
                Close
              </Button>
              <Button
                disabled={sppiner}
                variant="primary"
                onClick={handleFileUpload}
              >
                <span className="">Confirm</span>
                {sppiner && (
                  <Spinner
                    as="span"
                    style={{ marginLeft: "5px" }}
                    className="ml-2"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Info;
